function update(element: HTMLElement, value: string): void {
    // Get element (progress bar)
    const elProgressBar = element.querySelector<HTMLElement>('.progress-bar');
    // If there is no element (progress bar)
    if (!elProgressBar) {
        return;
    }

    // Update progress
    elProgressBar.style.width = value + '%';

    // Update text
    elProgressBar.textContent = value + '%';
}

function count(element: HTMLElement, current: number, total: number): number {
    // If total is invalid
    if (!Number.isFinite(total) || total <= 0) {
        update(element, '0');
        return 0;
    }

    // Clamp percentage between 0 and 100
    const percent = Math.max(0, Math.min(100, Math.round((current / total) * 100)));

    // Update progress UI
    update(element, String(percent));

    // Return
    return percent;
}

// ----------------------------------------------------------------------------

export { count, update };
